import { Browser } from "@capacitor/browser";
import cx from "classnames";
import { useRef } from "react";
import { Trans } from "react-i18next";

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "@/constants/legalLinks.constants";
import { useTranslation } from "@/core/i18n";
import { Icon } from "atoms/icon/Icon";
import RepeatMDLogo from "atoms/icon/icons/asset_Repeat_app_icon_small_ol.svg";
import { handleLinkClick } from "utils/androidByPassDeepLinkClick";
import { getAdminUrl } from "utils/functions";
import { isNativeMobileApp } from "utils/platform.helpers";

type RepeatMDFooterV3Props = {
  showLinks?: boolean;
  showShopTerms?: boolean;
};

export const RepeatMDFooterV3 = (props: RepeatMDFooterV3Props) => {
  const { t } = useTranslation();
  const anchorRef = useRef(null);
  return (
    <div>
      {props.showLinks && (
        <>
          <div className="flex items-center justify-center gap-6 px-0 pt-3">
            <button
              type="button"
              className="text-bold3 text-secondary"
              onClick={() => Browser.open({ url: TERMS_OF_SERVICE_URL })}
            >
              {t("repeatmdFooter.termsOfService")}
            </button>
            <button
              type="button"
              className="text-bold3 text-secondary"
              onClick={() => Browser.open({ url: PRIVACY_POLICY_URL })}
            >
              {t("repeatmdFooter.privacyPolicy")}
            </button>
            {!isNativeMobileApp() && (
              <a
                ref={anchorRef}
                className="text-bold3 text-secondary"
                href={getAdminUrl()}
                target="_self"
                rel="noopener noreferrer"
                onClick={() => {
                  handleLinkClick(anchorRef);
                }}
              >
                {t("repeatmdFooter.admin")}
              </a>
            )}
          </div>
          <div className="flex items-center justify-center gap-1.5 pb-7 pt-4 text-body3 text-secondary">
            <Icon svg={RepeatMDLogo} size="x3small" />
            {t("repeatmdFooter.poweredBy")} RepeatMD
          </div>
        </>
      )}
      {props.showShopTerms && (
        <span
          className={cx(
            "flex w-full justify-center gap-1 pb-1 text-chip text-primary",
            "flex-wrap font-normal",
          )}
        >
          <Trans
            i18nKey="repeatmdFooter.shopTermsAgreement"
            components={{
              privacy: (
                <button
                  className="text-brand-color"
                  rel="noopener noreferrer"
                  onClick={() => Browser.open({ url: PRIVACY_POLICY_URL })}
                />
              ),
              terms: (
                <button
                  className="text-brand-color"
                  rel="noopener noreferrer"
                  onClick={() => Browser.open({ url: TERMS_OF_SERVICE_URL })}
                />
              ),
            }}
          />
        </span>
      )}
    </div>
  );
};
